import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { VariableRate } from '../../../../../../../../ui/rate';

const WithdrawalFeeRate = ({
    feePercentage
}: {
    feePercentage: number | null;
}) =>
    feePercentage !== null ? (
        <VariableRate
            minimumFractionDigits={0}
            maximumFractionDigits={2}
            value={feePercentage}
        />
    ) : (
        <>--,-- %</>
    );

export const WithdrawalFeesRow = ({
    selectedOffer
}: {
    selectedOffer: TFormalOffer | undefined;
}) => {
    const feePercentage = selectedOffer?.withdrawal_fee_percentage ?? null;

    return (
        <div className="flex items-center justify-between">
            <Text>
                <FormattedMessage
                    id="_.loan_summary.withdrawal_fees"
                    defaultMessage="Withdrawal fees:"
                />
            </Text>
            <Text className="font-bold" data-testid="withdrawal-fees">
                {feePercentage === 0 && (
                    <>
                        <FormattedMessage
                            id="_.draw_down.choose_amount.always"
                            defaultMessage="always"
                        />{' '}
                    </>
                )}
                <WithdrawalFeeRate feePercentage={feePercentage} />
            </Text>
        </div>
    );
};
